import React, {useEffect, useState} from 'react';
import classNames from 'classnames';
import {subscribeToCampaign} from 'react-controlled-ab/datalayers/vwo';

import {usePhaseState} from 'funnel-schedule/phase-context';
import useBeacon from 'utils/useBeacon';
import track from 'utils/track';

import PageMeta from 'components/PageMeta';
import {SalesCopyEvergreen} from 'components/SalesCopy';
import ModalExitSales from 'components/Modals/ModalExitSales';
import Footer from 'components/Elements/Footer';

export default function SalesIndex({
  noExitIntent = false,
  noFixedVideo = false,
  ctaOverride = null,
  videoUrlOverride = null,
  ctaNoTimer = false,
  variant = 'default',
  ...props
}) {
  const pageTitle = 'Become a Certified Plant-Based Coach';
  const pageDescription =
    'Combine in-depth plant-based nutrition education, results-driven coaching skills, and practical training to help you create greater impact and income while making a meaningful difference in the world.';
  const ogImage =
    'https://s3.us-west-2.amazonaws.com/cdn.foodrevolution.org/pbcc/og/pbcc-2026-open-graph-sales-fb-tw.png';
  const shareUrl = 'https://certificate.foodrevolution.org/join/';

  useBeacon();
  return (
    <div className={classNames(`page`, `d-flex`, `flex-column`, `page-nosocial`)}>
      <PageMeta title={pageTitle} description={pageDescription} url={shareUrl} ogImage={ogImage} />
      <div className="page-content">
        <SalesCopyEvergreen version="sales" variant={variant} ctaOverride={ctaOverride} />
      </div>
      {!noExitIntent && <ModalExitSales />}
      <div className="footer-content mt-auto">
        <Footer adVariant={variant === 'ad'} />
      </div>
    </div>
  );
}
